<div class="content-box">
  <app-breadcrumb pagina="Estatísticas" [intermediarios]="trilha"></app-breadcrumb>

  <div class="element-wrapper">
    <div class="title-wrapper">
      <h1 class="estat-titulo">Estatísticas e-SIC</h1>
    </div>
  </div>

  <br />

  <div class="element-box mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="title-filter">
        <i-lucide name="funnel" color="var(--primary-color)"></i-lucide> Filtros de Busca
      </h6>
      <button type="button" class="btn btn-sm btn-outline-primary rounded-3" (click)="limparFiltros()">
        <strong style="font-size: 12px;">Limpar Filtros</strong>
      </button>
    </div>

    <form (ngSubmit)="aplicarFiltros()">
      <div class="row g-3 align-items-end filtros-bar">
        <div class="col-12 col-sm-6">
          <label for="dataInicio" class="form-label">Data inicial:</label>
          <input type="date" class="form-control filtro-control" id="dataInicio" name="dataInicio"
            [(ngModel)]="dataInicio" />
        </div>

        <div class="col-12 col-sm-6">
          <label for="dataFim" class="form-label">Data final:</label>
          <input type="date" class="form-control filtro-control" id="dataFim" name="dataFim" [(ngModel)]="dataFim" />
        </div>

        @if (erroFiltro(); as mensagem) {
        <div class="col-12">
          <div class="text-danger small" role="alert">{{ mensagem }}</div>
        </div>
        }

        <div class="d-flex justify-content-end mt-4">
          <button id="btn-pesquisar" class="btn btn-sm btn-aplicar-filtros" type="submit">
            Aplicar Filtros
          </button>
        </div>
      </div>
    </form>
  </div>

  @if (erro()) {
  <div class="alert alert-warning mt-3" role="alert">
    Não foi possível carregar as estatísticas agora. Tente novamente em instantes.
  </div>
  } @else if (carregando() || !dados()) {
  <div class="estat-aviso mt-3" role="status" aria-live="polite">
    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
    Carregando estatísticas…
  </div>
  } @else {
  @let estatisticas = dados()!;
  <div class="mt-3">
    <div class="d-flex flex-wrap mb-4">
      <div class="col-12">
        <h2 class="estat-secao-titulo">Dados Atuais</h2>
        <p class="text-muted mb-1">
          Informações registradas e publicadas diretamente no sistema vigente.
        </p>
        <p class="text-muted mb-3">Período: <strong>{{ periodo() }}</strong></p>
      </div>
    </div>

    <!-- Cards informativos -->
    <div class="row g-3 mb-4">
      <div class="col-sm-2">
        <div class="card h-100 shadow-sm estat-card" data-borda="recebidos">
          <div class="card-body d-flex flex-column justify-content-between">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="estat-card-title">Recebidos</span>
            </div>
            <div class="d-flex justify-content-between">
              <div>
                <div class="estat-card-label text-muted">Total</div>
                <div class="estat-card-value">{{ estatisticas.kpis.recebidos }}</div>
              </div>
              <div class="estat-card-divider"></div>
              <div>
                <div class="estat-card-label text-muted">Prazo</div>
                <div class="estat-card-value estat-card-value-prazo">
                  {{ estatisticas.prazo?.descricao ?? '—' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="card h-100 shadow-sm estat-card" data-borda="atendidos">
          <div class="card-body d-flex flex-column justify-content-between">
            <span class="estat-card-title">Atendidos</span>
            <div class="estat-card-value mt-2 mb-1">{{ estatisticas.kpis.atendidos }}</div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="estat-card-label">{{ percentualAtendidos() }}% total</span>
              <span class="estat-card-label">{{ estatisticas.kpis.atendidos }}/{{ estatisticas.kpis.recebidos }}</span>
            </div>
            <div class="progress estat-card-progress">
              <div class="progress-bar bg-dark" role="progressbar" aria-label="Percentual de pedidos atendidos"
                aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="percentualAtendidos()"
                [style.width.%]="percentualAtendidos()"></div>
              <div class="progress-bar bg-pink" [style.width.%]="100 - percentualAtendidos()"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="card h-100 shadow-sm estat-card" data-borda="parcial">
          <div class="card-body d-flex flex-column justify-content-between">
            <span class="estat-card-title">Parcialmente atendido</span>
            <div class="estat-card-value mt-2 mb-1">{{ estatisticas.kpis.parcialmenteAtendidos }}</div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="estat-card-label">{{ percentualParcial() }}% total</span>
              <span class="estat-card-label">{{ estatisticas.kpis.parcialmenteAtendidos }}/{{ estatisticas.kpis.recebidos
                }}</span>
            </div>
            <div class="progress estat-card-progress">
              <div class="progress-bar bg-dark" role="progressbar"
                aria-label="Percentual de pedidos parcialmente atendidos" aria-valuemin="0" aria-valuemax="100"
                [attr.aria-valuenow]="percentualParcial()" [style.width.%]="percentualParcial()"></div>
              <div class="progress-bar bg-pink" [style.width.%]="100 - percentualParcial()"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="card h-100 shadow-sm estat-card" data-borda="indeferidos">
          <div class="card-body d-flex flex-column justify-content-between">
            <span class="estat-card-title">Indeferidos</span>
            <div class="estat-card-value mt-2 mb-1">{{ estatisticas.kpis.indeferidos }}</div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="estat-card-label">{{ percentualIndeferidos() }}% total</span>
              <span class="estat-card-label">{{ estatisticas.kpis.indeferidos }}/{{ estatisticas.kpis.recebidos }}</span>
            </div>
            <div class="progress estat-card-progress">
              <div class="progress-bar bg-dark" role="progressbar" aria-label="Percentual de pedidos indeferidos"
                aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="percentualIndeferidos()"
                [style.width.%]="percentualIndeferidos()"></div>
              <div class="progress-bar bg-pink" [style.width.%]="100 - percentualIndeferidos()"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="card h-100 shadow-sm estat-card" data-borda="nao-respondidos">
          <div class="card-body d-flex flex-column justify-content-between">
            <span class="estat-card-title">Não respondidos</span>
            <div class="estat-card-value mt-2 mb-1">{{ estatisticas.kpis.naoRespondidos }}</div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="estat-card-label">{{ percentualNaoRespondidos() }}% no total</span>
              <span class="estat-card-label">{{ estatisticas.kpis.naoRespondidos }}/{{ estatisticas.kpis.recebidos
                }}</span>
            </div>
            <div class="progress estat-card-progress">
              <div class="progress-bar bg-dark" role="progressbar" aria-label="Percentual de pedidos não respondidos"
                aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="percentualNaoRespondidos()"
                [style.width.%]="percentualNaoRespondidos()"></div>
              <div class="progress-bar bg-pink" [style.width.%]="100 - percentualNaoRespondidos()"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3 mb-4">
      <div class="col-sm-12 mt-3">
        <div class="card mb-4">
          <div class="card-body">
            <h3 class="card-title negrito-graficos mb-3">Tendência Mensal</h3>
            <div class="mt-4" #graficoTendenciaMensal></div>
          </div>
        </div>
      </div>
    </div>

    <br />

    <div class="row">
      <!-- Primeira Coluna -->
      <div class="col-12 col-md-4">
        <h2 class="text-negrito">Respostas</h2>

        <ng-container
          *ngTemplateOutlet="linhaContagem; context: { $implicit: 'Informações fornecidas integralmente', quantidade: estatisticas.kpis.atendidos, percentual: getPercentual(estatisticas.kpis.atendidos) }"></ng-container>
        <ng-container
          *ngTemplateOutlet="linhaContagem; context: { $implicit: 'Informações fornecidas parcialmente', quantidade: estatisticas.kpis.parcialmenteAtendidos, percentual: getPercentual(estatisticas.kpis.parcialmenteAtendidos) }"></ng-container>
        <ng-container
          *ngTemplateOutlet="linhaContagem; context: { $implicit: 'Pedido indeferido', quantidade: estatisticas.kpis.indeferidos, percentual: getPercentual(estatisticas.kpis.indeferidos) }"></ng-container>
        <ng-container
          *ngTemplateOutlet="linhaContagem; context: { $implicit: 'Pedido redirecionado', quantidade: estatisticas.pedidosRedirecionados, percentual: getPercentual(estatisticas.pedidosRedirecionados) }"></ng-container>
      </div>

      <!-- Segunda Coluna -->
      <div class="col-12 col-md-4">
        <h2 class="text-negrito">Motivos</h2>

        @for (motivo of estatisticas.motivos; track motivo.chave) {
        <ng-container
          *ngTemplateOutlet="linhaContagem; context: { $implicit: motivo.rotulo, quantidade: motivo.quantidade, percentual: getPercentual(motivo.quantidade) }"></ng-container>
        }
      </div>

      <!-- Terceira Coluna -->
      <div class="col-12 col-md-4">
        <h2 class="text-negrito">Perfil dos Solicitantes</h2>

        @for (categoria of estatisticas.perfilSolicitantes.categorias; track categoria.chave) {
        <ng-container
          *ngTemplateOutlet="linhaContagem; context: { $implicit: categoria.rotulo, quantidade: categoria.quantidade, percentual: getPercentualPerfil(categoria.quantidade) }"></ng-container>
        }
      </div>
    </div>
  </div>

  <br />

  <div class="card">
    <div class="card-body">
      <h2 class="estat-solicitantes-titulo">Informações genéricas sobre os solicitantes</h2>

      <div class="row g-3 mt-4 graficos-solicitantes">
        <div class="col-12 col-lg-4">
          <div class="grafico-solicitante">
            <h3 class="grafico-solicitante-titulo">Estatística por Faixa Etária</h3>
            @if (estatisticas.faixaEtaria.publicado) {
            <div #graficoFaixaEtaria></div>
            } @else {
            <ng-container *ngTemplateOutlet="dadosInsuficientes"></ng-container>
            }
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="grafico-solicitante">
            <h3 class="grafico-solicitante-titulo">Estatística por Domicílio</h3>
            @if (estatisticas.domicilio.publicado) {
            <div #graficoDomicilio></div>
            } @else {
            <ng-container *ngTemplateOutlet="dadosInsuficientes"></ng-container>
            }
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="grafico-solicitante">
            <h3 class="grafico-solicitante-titulo">Estatística por Gênero</h3>
            @if (estatisticas.genero.publicado) {
            <div #graficoGenero></div>
            } @else {
            <ng-container *ngTemplateOutlet="dadosInsuficientes"></ng-container>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>

<ng-template #linhaContagem let-titulo let-quantidade="quantidade" let-percentual="percentual">
  <div class="card border-0 estat-card mb-3">
    <div class="card-body py-3 px-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <span class="estat-card-title">{{ titulo }}</span>
      </div>
      <div class="d-flex align-items-center">
        <span class="estat-card-value me-3">{{ quantidade }}</span>
        <div class="estat-card-progress flex-grow-1">
          <div class="progress-bar bg-dark" [style.width.%]="percentual"></div>
          <div class="progress-bar bg-pink" [style.width.%]="100 - percentual"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dadosInsuficientes>
  <p class="estat-aviso mb-0">Dados insuficientes para exibição neste período.</p>
</ng-template>
